import React from "react";
import { ManagePlanLayout, AccountBalanceComponent } from "../../../components";

const buttons = [];

function PlanAccountBalanceContainer(props) {
  return (
    <>
      <ManagePlanLayout buttons={buttons}>
        <div className="w-100">
          <AccountBalanceComponent />
        </div>
      </ManagePlanLayout>
    </>
  );
}

export default PlanAccountBalanceContainer;
